export default __webpack_public_path__ + "static/PromptIconThreeTeen-35e8f9255e3b9cb277ff45a681d4a988.png";